import { ReactNode } from "react";
import { useAuth } from "@/hooks/use-auth";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) {
    const redirectPath = `${location.pathname}${location.search}${location.hash}`;

    if (redirectPath && redirectPath !== "/auth") {
      sessionStorage.setItem("redirectAfterLogin", redirectPath);
    }

    return <Navigate to="/auth?tab=login" replace />;
  }

  return <>{children}</>;
}
